import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wrapper", "hidden", "list", "selected"]
  static values = { url: { type: String, default: "/tasks/calendar_events" } }

  connect() {
    this.typeSelect = this.element.querySelector("[name='task[task_type]']")
    if (this.typeSelect) {
      this.typeSelect.addEventListener("change", () => this.toggleVisibility())
      this.toggleVisibility()
    }
  }

  toggleVisibility() {
    if (!this.hasWrapperTarget) return
    const rdvTypes = ["rdv_prep_1", "rdv_prep_2", "rdv_prep_3", "meeting"]
    if (rdvTypes.includes(this.typeSelect.value)) {
      this.wrapperTarget.classList.remove("hidden")
    } else {
      this.wrapperTarget.classList.add("hidden")
    }
  }

  async loadEvents() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(this.urlValue, {
      headers: { "Accept": "application/json", "X-CSRF-Token": token }
    })

    if (!response.ok) return
    const events = await response.json()
    this.renderEvents(events)
  }

  renderEvents(events) {
    this.listTarget.innerHTML = ""
    this.listTarget.classList.remove("hidden")

    if (events.length === 0) {
      this.listTarget.innerHTML = '<p class="px-3 py-2 text-sm text-text-muted">Aucun evenement a venir</p>'
      return
    }

    events.forEach(event => {
      const startDate = new Date(event.start)
      const button = document.createElement("button")
      button.type = "button"
      button.className = "w-full text-left px-3 py-2 hover:bg-surface-3 rounded-lg text-sm transition-colors"
      const dateStr = startDate.toLocaleDateString("fr-FR", { day: "numeric", month: "short" })
      const timeStr = startDate.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
      button.innerHTML = `
        <span class="font-medium text-text-primary">${event.summary || "Sans titre"}</span>
        <span class="text-xs text-text-muted ml-2">${dateStr} ${timeStr}</span>
      `
      button.addEventListener("click", () => this.selectEvent(event))
      this.listTarget.appendChild(button)
    })
  }

  selectEvent(event) {
    this.hiddenTarget.value = event.id
    const startDate = new Date(event.start)
    const dateStr = startDate.toLocaleDateString("fr-FR", { day: "numeric", month: "short" })
    const timeStr = startDate.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
    this.selectedTarget.innerHTML = `
      <div class="flex items-center gap-2 px-3 py-2 bg-blue-500/10 rounded-lg border border-blue-500/20">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-blue-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
        </svg>
        <span class="text-sm text-text-primary truncate">${event.summary || "Sans titre"}</span>
        <span class="text-xs text-blue-600">${dateStr} ${timeStr}</span>
        <button type="button" class="ml-auto flex-shrink-0 text-text-muted hover:text-danger transition-colors" data-action="click->calendar-event-picker#clear">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    `
    this.selectedTarget.classList.remove("hidden")
    this.listTarget.classList.add("hidden")
  }

  clear(event) {
    event.stopPropagation()
    this.hiddenTarget.value = ""
    this.selectedTarget.classList.add("hidden")
    this.selectedTarget.innerHTML = ""
  }
}
